import axios from 'axios';

// const { REACT_APP_API_URL: API_URL } = import.meta.env;

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3002";

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor to include the auth token
axiosInstance.interceptors.request.use(
  (config) => {
    // Get the token from localStorage or your state management solution
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// You can also add response interceptors for global error handling (e.g., 401)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default axiosInstance;